import { db } from '@/data/firebase/config';
import { ALLOWED_DOMAINS } from '@/domain/env/allowed-domains';
import { DOCUMENTS_DB } from '@/domain/env/documents-db';
import { User } from '@/domain/types/user';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { useCallback, useState } from 'react';

const useUsersLogged = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<User[]>([]);

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    const collectionRef = collection(db, DOCUMENTS_DB.USERS);
    const q = query(collectionRef, where('isNew', '==', false));
    const querySnapshot = await getDocs(q);
    const users: User[] = querySnapshot.docs.map((doc) => ({
      ...(doc.data() as User),
      id: doc.id,
    }));
    // Filtrar usuarios: solo dominios permitidos y que estén habilitados
    const filtered = users.filter((u) => {
      if (!u.email || typeof u.email !== 'string') return false;
      const domain = u.email.split('@')[1]?.toLowerCase();
      return (
        u.isEnabled && ALLOWED_DOMAINS.some((d) => domain === d.toLowerCase())
      );
    });
    setData(filtered);
    setIsLoading(false);
  }, []);

  return { isLoading, data, fetchData };
};

export default useUsersLogged;
